export default "7b52ac6f38f16ef8.woff2"